import { render, staticRenderFns } from "./IconBox.vue?vue&type=template&id=7eb4b768&functional=true&"
import script from "./IconBox.vue?vue&type=script&lang=js&"
export * from "./IconBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports